import { useCallback, useEffect, useRef, useState } from "react";
import { Box, Text } from "grommet";

/**
 * Lightweight bottom-right "Saved" indicator.
 */
export function SavedToast({ visible, message = "Saved" }) {
  if (!visible) return null;

  return (
    <Box
      round="small"
      pad={{ horizontal: "medium", vertical: "small" }}
      background="dark-1"
      elevation="medium"
      style={{
        position: "fixed",
        right: 16,
        bottom: 16,
        zIndex: 1000,
        pointerEvents: "none",
        opacity: 0.92,
      }}
    >
      <Text size="small" color="light-1">
        {message}
      </Text>
    </Box>
  );
}

export function useSavedToast(durationMs = 1800) {
  const [visible, setVisible] = useState(false);
  const [message, setMessage] = useState("Saved");
  const timeoutRef = useRef(null);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  const showSaved = useCallback(
    (nextMessage = "Saved") => {
      setMessage(nextMessage);
      setVisible(true);

      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        setVisible(false);
      }, durationMs);
    },
    [durationMs],
  );

  return {
    showSaved,
    savedToastProps: { visible, message },
  };
}
